var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhymeHumen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 305,
    viewBox: "0 0 298 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.685 35.6879C127.329 17.9795 144.691 4.94437 168.488 10.1617C235.551 24.8616 222.651 128.626 156.311 133.299C102.595 137.086 82.4979 45.5186 125.862 32.6848",
    stroke: "white",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.383 162.91C107.214 189.859 110.876 213.069 114.369 232.538C117.862 252.007 120.651 273.033 122.736 295.618",
    stroke: "white",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.235 169.822C190.811 183.515 184.568 212.88 179.87 239.947C174.675 269.88 171.117 297 171.117 297",
    stroke: "white",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.235 163.218C179.059 163.218 127.928 156.526 113.844 158.311C109.186 158.893 104.521 159.485 99.8638 160.067C97.8608 160.321 95.844 160.678 93.8299 160.816C86.1241 161.354 23.168 178.283 20.3345 178.115C19.6641 178.072 19.0075 178.031 18.3398 177.977C17.0348 177.871 14.858 177.809 13.8454 177.428C11.7127 176.603 9.79246 175.959 8.11224 174.312C7.41253 173.63 9.93076 155.275 17.1742 125.505C23.8686 97.9908 34.0504 73.9198 36.1044 72.1946C38.1322 70.5042 52.116 59.2324 52.985 59.2324C54.4666 59.2324 55.9371 59.5435 57.4325 59.7652C59.6618 60.1033 65.3955 64.6676 66.3777 65.8847C68.4249 68.4407 66.9853 71.799 63.3235 77.188C59.6618 82.5771 51.4281 82.5771 48.487 85.0059",
    stroke: "white",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.236 163.219C208.263 163.219 285.817 192.868 287.173 194.885C288.593 197.006 290 198.918 290 201.358C290 205.658 286.853 209.598 283.122 212.782C277.918 217.217 272.012 221.174 266.383 225.315C263.063 227.752 259.732 230.2 256.412 232.637C251.181 236.48 201.811 268.848 196.102 272.25C192.095 274.641 187.989 276.988 184.309 279.643C184.234 280.191 184.088 280.742 183.877 281.285C183.398 282.489 177.562 295.928 176.647 297",
    stroke: "white",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhymeHumen);
export default __webpack_public_path__ + "static/media/whyme_humen.22b95e09b546bd639e9e165743677135.svg";
export { ForwardRef as ReactComponent };